var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse, _path38, _ellipse2, _ellipse3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtc02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.607422,
    y: 0.826172,
    width: 350,
    height: 233,
    fill: "#464497"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.264 177.267C215.052 181.787 224.238 182.481 230.071 182.481C234.933 182.206 236.71 179.878 236.546 178.869C236.249 177.037 236.894 175.894 234.365 173.147C231.835 170.4 217.099 161.015 209.951 157.925C202.803 154.835 194.989 153.505 192.026 156.437C189.97 158.472 190.372 161.983 192.026 165.128C193.309 167.569 198.764 173.41 206.264 177.267Z",
    fill: "#0F0D22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260.317 139.043C271.331 145.857 280.359 145.259 284.232 145.259C290.81 145.057 292.983 142.122 292.831 141.239C292.556 139.637 293.153 138.638 290.81 136.236C288.466 133.834 274.812 125.628 268.189 122.926L268.159 122.914C261.539 120.213 252.655 116.588 249.915 119.148C248.01 120.928 248.866 126.417 250.399 129.167C251.932 131.917 253.759 134.986 260.317 139.043Z",
    fill: "#0F0D22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.173 133.93C174.796 132.066 173.189 128.217 173.189 124.684C173.375 119.82 174.656 122.96 175.628 122.96C176.599 122.96 178.828 127.007 179.476 130.424C180.123 133.842 195.514 150.418 182.971 141.135C179.709 138.719 177.529 135.767 176.191 133.956L176.173 133.93Z",
    fill: "#0F0D22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.686 125.106C174.151 135.065 187.711 144.869 194.433 148.526L194.164 137.244C191.939 135.708 186.824 132.683 180.52 127.067C175.476 122.575 173.862 114.565 173.686 111.121V125.106Z",
    fill: "#1F1753"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.454 148.546L194.176 137.521L196.282 135.992L196.397 146.741L194.454 148.546Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.788 146.747L194.602 139.112L195.954 138.006L196.058 145.597L194.788 146.747Z",
    fill: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.788 146.744L194.602 139.109L200.968 142.669L200.072 149.701L194.788 146.744Z",
    fill: "#3B3563"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.601 135.371C289.416 136.614 289.577 139.57 288.6 141.849",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.348 136.488C290.709 137.254 291.215 139.318 290.348 141.445",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M300.68 129.498C301.844 129.703 303.982 130.838 303.222 133.743",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.25 131.381C302.547 131.667 303.051 132.674 302.695 134.406",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M303.08 118.624C303.565 118.387 304.665 117.942 305.187 118.061",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M303.527 117.231C303.764 117.103 304.346 116.845 304.773 116.846",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.471 123.157C300.057 122.956 301.38 122.675 301.984 123.157",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299.615 122.349C299.823 122.163 300.582 121.78 301.953 121.742",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M273.054 102.775C273.063 101.923 272.894 99.9571 272.145 98.9121",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.562 102.635C273.742 101.679 273.891 99.3859 273.051 97.8633",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M289.602 107.015C289.766 106.282 290.364 104.699 291.441 104.232",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M290.166 107.57C290.379 106.855 291.175 105.228 292.65 104.445",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M240.648 179.26C240.366 179.462 239.511 179.679 238.35 178.938",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M241.424 178.596C241.154 178.742 240.463 178.892 239.867 178.324",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M247.351 167.252C246.945 167.353 245.739 167.496 244.168 167.252",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M247.452 166.439C247.024 166.552 245.902 166.71 244.846 166.439",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M240.537 173.447C240.792 173.888 241.56 174.815 242.601 174.995",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M240.785 172.932C240.935 173.29 241.471 174.039 242.423 174.165",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.462 131.951C216.756 131.454 212.857 134.235 211.496 135.689C215.326 148.032 220.441 173.73 220.995 177.551C221.687 182.327 236.369 183.335 240.591 179.459C244.034 176.66 247.255 171.251 247.763 164.135C248.179 158.324 244.718 147.94 239.181 141.71C233.644 135.481 227.345 132.574 221.462 131.951Z",
    fill: "#141414"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.983 134.656C210.943 135.162 210.801 136.458 210.139 137.309C216.556 151.644 228.347 180.168 230.448 180.829C233.075 181.655 239.063 178.092 241.097 171.59C242.926 166.561 242.038 159.657 240.484 155.418C237.48 147.227 231.378 140.296 225.377 136.824C219.262 133.287 213.888 134.431 212.983 134.656Z",
    fill: "#BBB7D1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.529 135.336L202.611 140.811C202.529 148.623 203.751 165.694 209.301 171.479C216.239 178.71 222.248 180.322 227.476 181.153C232.704 181.983 236.01 178.329 236.997 177.146L237.025 177.112C238.427 175.431 241.998 171.15 240.855 161.135C238.15 148.657 230.228 141.403 224.72 137.866C219.84 134.732 213.963 134.7 211.529 135.336Z",
    fill: "#3F3A5A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M201.046 142.709L194.602 139.112L195.954 138.006L202.317 141.559L201.046 142.709Z",
    fill: "#CFC8FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M256.141 112.697L256.139 98.1205L257.965 96.25L257.967 110.974L256.141 112.697Z",
    fill: "#A9A9A9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M193.513 109.87C184.879 114.347 180.573 122.024 181.569 126.137C178.321 122.881 177.129 121.254 176.815 119.735C175.819 116.199 173.913 110.284 178.691 105.443C184.663 99.3921 191.863 95.7415 202.657 93.1929C211.734 91.0496 224.055 90.2327 235.76 91.8203C245.274 93.1109 253.757 96.0559 256.141 97.8108V112.555C252.777 111.463 249.526 109.842 233.81 106.463C218.093 103.084 203.71 104.581 193.513 109.87Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M207.333 139.243C198.463 139.746 198.14 149.791 198.727 154.858C199.732 160.428 202.49 164.533 205.658 168.348C215.732 179.957 225.004 178.07 227.1 176.975C229.319 175.817 234.697 170.895 233.214 162.611C232.075 156.245 226.616 149.475 224.252 147.074C221.847 144.631 215.562 138.776 207.333 139.243Z",
    fill: "#1F1753"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M207.613 144.41C198.433 144.554 198.718 153.08 200.008 157.326C203.158 166.553 211.314 172.932 214.543 174.333C218.212 175.926 226.018 175.548 227.863 170.238C229.708 164.928 227.391 159.831 226.954 158.871C226.73 158.379 219.088 144.23 207.613 144.41Z",
    fill: "#988DDB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M262.904 103.512L256.459 99.9152L257.812 98.8086L264.174 102.362L262.904 103.512Z",
    fill: "#D2D2D2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M256.645 110.113L256.459 99.9141L262.826 103.474L261.929 113.07L256.645 110.113Z",
    fill: "#989898"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M196.298 135.989L194.174 137.517C182.305 131.432 176.846 124.22 174.94 119.102C171.388 109.571 176.422 104.816 179.382 102.062C182.791 98.619 192.615 91.9302 206.356 90.1477C213.615 89.206 219.398 88.6483 227.885 89.1435C244.651 90.3958 254.913 94.3943 257.957 96.2495L256.118 98.1345C254.17 97.0214 247.131 94.7284 243.71 93.9554C238.642 92.9028 226.05 90.9846 216.225 91.7331C203.945 92.6687 198.609 94.1315 196.27 95.0671C193.931 96.0027 187.583 97.9521 182.398 102.396C177.751 106.38 176.519 108.722 176.158 111.09C175.022 122.88 189.529 132.703 196.298 135.989Z",
    fill: "#CFC8FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M250.825 120.947C250.715 119.794 251.739 116.214 252.265 114.568L253.843 117.518L261.114 128.698C266.053 131.671 275.985 137.657 276.205 137.821C276.424 137.986 289.009 137.25 295.274 136.861C298.177 134.757 303.738 131.236 302.75 133.98C301.516 137.41 296.303 145.504 281.143 144.886C265.984 144.269 257.807 135.844 254.581 131.49C251.558 127.411 250.962 122.388 250.825 120.947Z",
    fill: "#3F3A5A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.865,
    cy: 119.628,
    rx: 28.4142,
    ry: 21.2907,
    transform: "rotate(22.8984 278.865 119.628)",
    fill: "#141414"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M260.713 132.931C260.831 132.152 261.294 130.41 262.2 129.674",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.396,
    cy: 116.083,
    rx: 13.3341,
    ry: 8.10345,
    transform: "rotate(22.8984 279.396 116.083)",
    fill: "#534B7E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.722,
    cy: 117.921,
    rx: 11.3973,
    ry: 6.92638,
    transform: "rotate(22.8984 280.722 117.921)",
    fill: "#141414"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.01 127.536C286.149 131.818 296.477 130.295 299.079 124.134C301.682 117.973 295.573 109.506 285.435 105.224C275.296 100.942 264.968 102.465 262.365 108.626C259.763 114.788 265.872 123.254 276.01 127.536ZM278.028 122.762C283.826 125.211 289.733 124.34 291.222 120.816C292.71 117.292 289.216 112.45 283.418 110C277.619 107.551 271.712 108.423 270.224 111.946C268.735 115.47 272.229 120.312 278.028 122.762Z",
    fill: "#988DDB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M251.631 117.344C251.93 116.181 252.986 113.655 254.817 112.85",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M252.182 120.045C252.323 119.006 252.897 116.787 254.058 116.221",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M259.83 132.224C260.078 130.95 261.091 128.011 263.158 126.453",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M258.996 131.431C259.062 130.219 259.68 127.569 261.624 126.666",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M275.987 127.6C276.008 128.428 275.836 130.367 274.98 131.501",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M276.781 127.943C276.876 128.279 277.008 129.139 276.781 129.894",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M234.304 137.301C233.948 137.351 233.181 137.611 232.961 138.246",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M233.724 136.83C233.173 137.02 231.957 137.597 231.504 138.39",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M243.752 149.129C243.333 149.257 242.253 149.659 241.285 150.24",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M244.225 149.752C243.903 149.86 243.121 150.181 242.572 150.6",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M218.753 134.34C218.709 133.927 218.853 132.991 219.782 132.547",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M219.281 134.5C219.308 134.192 219.493 133.513 220.021 133.26",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M227.227 137.852C227.35 137.482 227.749 136.716 228.361 136.611",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M236.066 146.773C236.365 146.377 237.159 145.555 237.94 145.428",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M236.277 147.089C236.559 146.807 237.238 146.212 237.703 146.086",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M203.383 156.729L206.84 151.848L208.755 153.204C209.864 153.989 210.017 155.124 209.336 156.085C208.646 157.06 207.524 157.272 206.398 156.475L205.521 155.854L204.395 157.446L203.383 156.729ZM206.099 155.038L206.814 155.544C207.414 155.969 207.946 155.84 208.291 155.345C208.638 154.862 208.576 154.327 207.979 153.899L207.264 153.393L206.099 155.038Z",
    fill: "#AAA0E7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M207.979 160.075C207.662 159.85 207.585 159.416 207.814 159.107C208.027 158.792 208.462 158.721 208.777 158.949C209.079 159.158 209.16 159.594 208.94 159.905C208.718 160.218 208.279 160.287 207.979 160.075Z",
    fill: "#AAA0E7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M209.405 160.993L212.861 156.111L214.776 157.467C215.885 158.252 216.038 159.388 215.358 160.349C214.668 161.323 213.545 161.535 212.419 160.738L211.543 160.118L210.416 161.709L209.405 160.993ZM212.12 159.302L212.835 159.808C213.435 160.233 213.967 160.103 214.312 159.609C214.659 159.125 214.598 158.591 214 158.162L213.285 157.656L212.12 159.302Z",
    fill: "#AAA0E7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M218.141 159.849L214.684 164.731L213.686 164.024L217.143 159.143L218.141 159.849Z",
    fill: "#AAA0E7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M217.066 166.528C215.946 165.73 215.771 164.518 216.595 163.361C217.392 162.229 218.632 161.958 219.704 162.717C220.664 163.397 220.993 164.541 220.11 165.789L219.91 166.072L217.408 164.301C217.017 164.854 217.103 165.426 217.616 165.794C217.959 166.032 218.307 166.056 218.56 165.906L219.51 166.579C218.889 167.156 217.972 167.165 217.066 166.528ZM217.852 163.674L219.41 164.777C219.721 164.329 219.641 163.792 219.194 163.48C218.738 163.152 218.171 163.267 217.852 163.674Z",
    fill: "#AAA0E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc02);
export default __webpack_public_path__ + "static/media/etc_02.d0cd6dfb5e5e0a6c6b560fff7669dfbb.svg";
export { ForwardRef as ReactComponent };